function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { useCallback, useMemo, useState } from "react";
import PictureComponent from "components/core/picture/picture-component";
import { StyledTagsAndAssetsComponent } from "./tags-and-assets-component.scss";
import ClickableTagsGrid from "segments/desktop/core-components/clickable-tags-grid/clickable-tags-grid";
import AssetComponent from "components/core/asset/asset-component";
import { trackEvent } from "services/bigbrain-service";
import { TAGS_DEFAULT_ASSET_CLICKED } from "constants/bigbrain-event-types";
const TagsAndAssetsComponent = ({ tagsTitle, tags, defaultImage, onClustersChange, extraDetails, enabledDefaultImageAnimation })=>{
    const [latestSelectedTab, setLatestSelectedTab] = useState(null);
    const [didDefaultClicked, setDidDefaultClicked] = useState(false);
    const tagAssets = useMemo(()=>tags === null || tags === void 0 ? void 0 : tags.map(({ tagImage })=>tagImage), [
        tags
    ]);
    const onTagSelectionChange = useCallback((selectedTags)=>{
        setLatestSelectedTab(selectedTags[selectedTags.length - 1] || null);
        onClustersChange(selectedTags);
    }, []);
    const onAssetClick = ()=>{
        if (latestSelectedTab) return;
        setDidDefaultClicked(true);
        trackEvent(TAGS_DEFAULT_ASSET_CLICKED);
    };
    return /*#__PURE__*/ _jsxs(StyledTagsAndAssetsComponent, {
        className: "tags-and-assets-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classnames("use-cases-container", {
                    "with-extra-details": !!extraDetails,
                    breathe: enabledDefaultImageAnimation && didDefaultClicked
                }),
                onAnimationEnd: ()=>setDidDefaultClicked(false),
                children: /*#__PURE__*/ _jsx(ClickableTagsGrid, {
                    onTagSelectionChange: onTagSelectionChange,
                    tags: tags,
                    tagsTitle: tagsTitle,
                    extraDetails: extraDetails
                })
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "assets-container",
                onClick: onAssetClick,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: classnames("default-asset", {
                            active: !latestSelectedTab
                        }),
                        children: /*#__PURE__*/ _jsx(AssetComponent, _object_spread({
                            hideControls: true
                        }, defaultImage))
                    }),
                    tagAssets === null || tagAssets === void 0 ? void 0 : tagAssets.map((tagAsset, index)=>/*#__PURE__*/ _jsx("div", {
                            className: classnames("picture-wrapper", {
                                selected: latestSelectedTab === tags[index]
                            }),
                            children: /*#__PURE__*/ _jsx(PictureComponent, {
                                src: (tagAsset === null || tagAsset === void 0 ? void 0 : tagAsset.src) || (defaultImage === null || defaultImage === void 0 ? void 0 : defaultImage.src)
                            }, index)
                        }))
                ]
            })
        ]
    });
};
export default TagsAndAssetsComponent;
